import type { FlashOfferRoomDraft } from '../RoomsStep/utils';

export interface RoomRateRoom {
  id: string;
  name: string;
  hasRatePlan: boolean;
}

type RoomRateSource = Pick<App.RoomType, 'id' | 'name'> & {
  room_rates?: Array<{ rate_plan?: { id?: string | null } | null }>;
};

type BuildRoomRateRoomsParams = {
  appliedRoomTypeIds?: Array<string>;
  ratePlanIds?: Array<string>;
  roomDrafts: Array<FlashOfferRoomDraft>;
  roomTypes: Array<RoomRateSource>;
};

function roomHasAllRatePlans(
  roomRates: Array<{ rate_plan?: { id?: string | null } | null }>,
  ratePlanIds: Array<string>,
) {
  return ratePlanIds.every((ratePlanId) => roomRates.some((roomRate) => roomRate.rate_plan?.id === ratePlanId));
}

export function buildRoomRateRooms({
  appliedRoomTypeIds = [],
  ratePlanIds = [],
  roomDrafts,
  roomTypes,
}: BuildRoomRateRoomsParams) {
  const roomsById = new Map<string, RoomRateRoom>();
  const appliedRoomTypeIdSet = new Set(appliedRoomTypeIds);

  roomTypes.forEach((roomType) => {
    if (!roomType.id) {
      return;
    }

    roomsById.set(roomType.id, {
      id: roomType.id,
      name: roomType.name || roomType.id,
      hasRatePlan:
        appliedRoomTypeIdSet.has(roomType.id) ||
        (ratePlanIds.length > 0 && roomHasAllRatePlans(roomType.room_rates ?? [], ratePlanIds)),
    });
  });

  roomDrafts.forEach((roomDraft) => {
    if (!roomDraft.id || roomsById.has(roomDraft.id)) {
      return;
    }

    roomsById.set(roomDraft.id, {
      id: roomDraft.id,
      name: roomDraft.existingRoomName || roomDraft.name || roomDraft.id,
      hasRatePlan: appliedRoomTypeIdSet.has(roomDraft.id),
    });
  });

  return Array.from(roomsById.values());
}
